import { FC } from "react";
import "./style.scss";
import "./style-mob.scss";

interface IAdvantagesCard {
  name: string;
  image: string;
}

const AdvantagesCard: FC<IAdvantagesCard> = ({ name, image }) => {
  return (
    <div className="advantages-card">
      <div className="advantages-card-content">
        <div className="advantages-card-img">
          <img src={image} alt="Advantages Img" />
        </div>
        <div className="advantages-card-name">
          <p>{name}</p>
        </div>
      </div>
    </div>
  );
};

export default AdvantagesCard;
